import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import PropTypes from 'prop-types';
import { StyledFormControl } from './styled';
import { useValidationMessage } from './hooks';
import Title from '../../Title';
import Select, { NONE } from '../../../../../forms/_common/Select';
import WebhookBasicAuth from './WebhookBasicAuth';
import { useNodeDataToSave } from './hooks/useNodeDataToSave';
import JsonInputField from './JsonInputField';

const DelayActionWebhookField = ({ titleSize }) => {
  const { t } = useTranslation();
  const [{ methods, selectedMethod }, updateDataToSave] = useNodeDataToSave();

  const options = useMemo(
    () =>
      methods?.map((type) => ({
        value: type,
        title: type,
      })),
    [methods]
  );

  const onChange = ({ target }) => updateDataToSave({ selectedMethod: target.value });

  const validationMessage = useValidationMessage('method');
  const isValid = Boolean(validationMessage);

  return (
    <Box>
      <Title fontSize={titleSize}>{t('HTTP Method')}</Title>
      <StyledFormControl fullWidth error={isValid}>
        <Select name="method" value={selectedMethod ?? NONE} options={options} onChange={onChange} />
        <FormHelperText>{validationMessage}</FormHelperText>
      </StyledFormControl>
      <WebhookBasicAuth />
      {selectedMethod === 'POST' && <JsonInputField title="Body JSON Structure" />}
    </Box>
  );
};

DelayActionWebhookField.propTypes = {
  titleSize: PropTypes.string,
};

DelayActionWebhookField.defaultProps = {
  titleSize: '16px',
};

export default DelayActionWebhookField;
